// extracted by mini-css-extract-plugin
module.exports = {"btnstyle_qobi":"button_btnstyle_qobi__2ILPY"};